import React from "react";
import { Layout } from "../../layouts/Layout";

const LegalDisclaimer = () => {
  return (
    <Layout title="Unified Legal Disclaimer">
      <div
        className="container pt-120 pb-100"
        style={{ textTransform: "none !important" }}
      >
        <div className="blog-details-content">
          <h2 className="title">Unified Legal Disclaimer</h2>
          <p>
            These policies apply uniformly to all purchases — retail, online,
            wholesale, or third-party — under Kadle Global Pvt Ltd.
          </p>
          <p>
            The Company reserves the right to modify, amend, or replace these
            policies at its discretion and without prior notice.
          </p>
          <p>
            Kadle Global Pvt Ltd shall not be liable for any damages, losses, or
            claims — direct or indirect — resulting from the misuse,
            misrepresentation, or miscommunication of its products, services, or
            brand identity.
          </p>
          <p>
            Any individual or entity attempting to cause financial,
            reputational, or operational harm to the Company shall be held
            accountable under relevant civil and criminal laws of India.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default LegalDisclaimer;
